export const Box = () => {
    return (
        <svg fill="currentColor" aria-hidden="true" viewBox="0 0 65 65">
            <path
                d="M16.462 33.807h32.932v21.747H16.462V33.807Z"
                opacity=".5"
            />
            <path d="M8.384.875h20.815v13.98h7.457V.876H57.47a7.456 7.456 0 0 1 7.457 7.456V57.42a7.456 7.456 0 0 1-7.457 7.456H8.384a7.456 7.456 0 0 1-7.456-7.456V8.33A7.456 7.456 0 0 1 8.384.875Zm40.277 33.554H17.083v20.505h31.578V34.429Z" />
        </svg>
    );
};
